dPJS = window.PJS || {};


(function ($) {
  PJS.layout = {
    headerHeight: null,
    mobilenavshow: false,
    waypoints: null,
    isscrolling: false,
    scrolltimer: null,
    impactmaptimer: null,
    impactmapanimtimer: null,
    impactmapactive: 0,
    impactmapdelay: 4000,
    impactmapresume: 8000,
    boxanims: [],
    $joinmodal: null,
    pagesliders: [],
    slidespeed: 5000,
    slidespeedhero: 5000,
    skipanims: false,
    init: function () {
      var _this = this;


      _this.contentadjustments();
      _this.menufixes();
      _this.outboundlinks();
      _this.donatelinks();
      _this.offcanvasmenu();
      _this.linkscroll();
      _this.searchempty();
      _this.searchmobile();
      _this.bodyboxes();
      _this.initjoin();

      _this.termdropdown();

      _this.submenuvert();

      _this.initslider();
      //_this.initwaypoints();  // js file excluded from header

      _this.initCauses();
      _this.initPartners();

      $(".cause-slider,.dotloc").on("mouseover, mouseenter", ".clickonhover", function () {
        if ($(this).attr("aria-selected") != "true") {
          $(this).trigger("click");
          console.log("[clickonhover] Trigger click");
        }
      });

      _this.initImpactNumbers();
      _this.initImpactMap();

      // CHARGE UP ANIMATIONS


      _this.skipanims = _this.skipanims || (PJS.helpers.getQParams("searchwp") != "");
      _this.skipanims = _this.skipanims || (PJS.helpers.getQParams("s") != "");
      _this.skipanims = _this.skipanims || (window.skipanims == true);

      if (!_this.skipanims) {
        $(".layout_reveal").addClass("ready");
      }


      $(".layout_impact,.style-body-lgrey:not(.style-box),.style-news-lgrey").wrap("<div class='bg-grey'></div>");
      //$(".style-quote-blue").wrap("<div class='bg-blue'></div>");
      //$(".style-quote-lblue").wrap("<div class='bg-lblue'></div>");

      $(".style-quote-bio").each(function () {
        $contentpush = $(this).next().find(".layout_bodycontent .block_wrap");
        if ($contentpush.length) {
          $contentpush.css("padding-top", "60px");
        }
      });

      PJS.documentEvents.onResize(_this.submenuvert.bind(_this), true);

      PJS.documentEvents.onResize(_this.fixedheader.bind(_this), true);
      PJS.documentEvents.onScroll(_this.fixedheader.bind(_this), true);
      _this.fixedheader();

      PJS.documentEvents.onScroll(_this.scrolltopdisplay.bind(_this), true);
      _this.scrolltopdisplay();

      PJS.documentEvents.onScroll(_this.triggervideos.bind(_this), true);
      _this.triggervideos();
      PJS.documentEvents.onScroll(_this.triggeranims.bind(_this), true);
      setTimeout(function () {
        PJS.layout.triggeranims(); // delay animations to allow transitions on load
      }, 100);


      // add in legacy qualifier to sections, use united for new sections
      $(".section:not(.united)").addClass("legacy");

      _this.loadtranslate();
      _this.hashCheck();
    },
    loadtranslate: function () {
      // load google translate secondary to help loading, set in script enqueue
      if (window.gtrans_script) {
        setTimeout(function () {
          PJS.helpers.loadScript(window.gtrans_script, PJS.layout.translateLoaded);
        }, 100);
      }
    },
    translateLoaded: function () {
      $("body").addClass("googletranslate");
    },
    triggervideos: function () {
      if (!PJS.helpers.isDesktopSize()) {
        // only trigger videos on desktop;
        return;
      }
      $(".wp-video").each(function () {
        var $video = $(this).find("video");
        if ($video.length) {
          var _pagebottom = $(window).scrollTop() + $(window).innerHeight();
          if ($(this).offset().top + $(this).height() < _pagebottom) {
            var _video = $video.get(0);
            //console.log(_video);
            if (_video.paused && !$(this).hasClass("autoplaying")) {
              console.log("[triggervideos] AUTO PLAYING VIDEO");
              $(this).find(".mejs-overlay-play").trigger("click");
              $(this).find(".mejs-mute button").trigger("click");
              $(this).addClass("autoplaying");
            }
          }
        }
      });
    },
    triggeranims: function () {
      var _this = this;


      var _pagebottom = $(window).scrollTop() + $(window).innerHeight();



      var _buffer = $(window).innerHeight() * .20; // percentage of window

      $(".lazyscroll").not(".lazyloaded").each(function () {
        if (_pagebottom > $(this).offset().top - _buffer) {
          $(this).trigger("lazyload");
          $(this).addClass("lazyloaded");
        }
      });

      $(".layout_reveal").not(".scrollreveal").each(function () {
        if (_pagebottom > $(this).offset().top + _buffer) {
          console.log("[triggeranims] reveal");
          $(this).addClass("scrollreveal");
          if ($(this).find(".impact_slides").length) {
            $(this).find(".slick-active .impact_boxes").trigger("animboxes");
          }
          else {
            $(this).find(".impact_boxes").trigger("animboxes");
          }
        }
      });

      $(".layout_reveal .post-item").not(".postanim").each(function () {
        if (_pagebottom > $(this).offset().top + _buffer) {
          $(this).addClass("postanim");
        }
      });

      if (PJS.layout.pagesliders.length) {
        $.each(PJS.layout.pagesliders, function (i, $slider) {
          if ($slider.hasClass("playing")) {
            return;
          }

          if (_pagebottom > $slider.offset().top) {
            //console.log("start slick");
            $slider.slick('slickSetOption', 'autoplay', true, true);
            $slider.addClass("playing");
          }
        });
      }

    },
    initImpactNumbers: function () {

      var _this = this;
      // animate impact box rows
      $(".impact_boxes").each(function () {
        $(this).on("animboxes", function (e) {
          var $boxes = $(this).find(".impact_box");
          //PJS.layout.boxanims.forEach(clearTimeout); // if scroll too fast stops animation
          $boxes.each(function (i) {
            var $box = $(this);
            $box.parent().addClass("hidebox").removeClass("showbox");
            PJS.layout.boxanims.push(setTimeout(function () {
              $box.parent().addClass("showbox");
              $box.trigger("anim");
            }, 1));
            //}, i * 500 + 500));

          });

        });
      });

      $(".number_anim").each(function () {
        var $animitem = $(this).find(".number_anim_item");
        var _animitemtext = $animitem.text()
        var _animitemnum = _animitemtext.replace(/[^.,\d]/g, '');

        if (_animitemnum && _animitemnum != "") {
          $animitem.html("<span class='counter-wrap'>" + _animitemtext.replace(_animitemnum, "<span class='counter'>" + _animitemnum + "</span>") + "</span>");
        }

        var $counter = $(this).find(".counter");
        if (!$counter.length) {
          console.log("[initImpactNumbers] NO NUMBER FOUND");
          console.log(_animitemtext, _animitemnum);
          return;
        }


        $(this).addClass("hasanim");

        var $counter = $(this).find(".counter");
        var $counterwrap = $(this).find(".counter-wrap");
        var _cnum = $counter.text();
        var _cnum = _cnum.replace(/,/g, ''); // remove all commas        
        var _mult = PJS.helpers.getMult(_cnum);
        var _pad = (('' + _mult).split("0").length - 1);

        $(this).on("anim", function (e) {
          console.log("[initImpactNumbers : animate]");
          $(this).addClass("animating");

          $counterwrap.width($counterwrap.width()); // fix width to prevent movement
          $counterwrap.height($counterwrap.height()); // fix width to prevent movement

          if (isNaN(_cnum)) {
            console.log("[initImpactNumbers] NOT A NUMBER");
            return;
          }
          var _duration = 700;
          if ($(this).data("duration")) {
            _duration = $(this).data("duration");
          }

          $({ Counter: 0 }).finish().animate({
            Counter: _cnum
          }, {
            duration: _duration,
            easing: 'easeOutQuad',
            step: function () {
              var _num = (Math.ceil(this.Counter * _mult) / _mult).toFixed(_pad);
              $counter.text(PJS.helpers.formatnum(_num));
            },
            complete: function () {
              $counter.text(PJS.helpers.formatnum(_cnum));
              $counter.parent().width("auto");
              $counter.parent().height("auto");
            }
          });

        });


      });
    },
    termdropdown: function () {
      var _this = this;
      $termtabs = $(".termtabs").not(".tabbed");
      if (!$termtabs.length)
        return;
      $termtabs.each(function () {
        $active = $(this).find(".active");

        $(this).wrapInner("<div class='termwrap'></div>");
        if ($active.length) {
          $activeitem = $active.clone().addClass("selector");
        }
        else {
          var _label = $(this).data("label");
          if (!_label || _label == "") {
            _label = "Category";
          }
          $activeitem = $('<a class="selector" href="#">Select ' + _label + '</a>');
        }

        $(this).prepend($activeitem);
        $activeitem.on("click", function (e) {
          $target = $(this).parent();
          if (PJS.helpers.isDesktopSize() && $target.hasClass("hoverdrop")) {
            return stopclick(e);
          }
          if (!$target.hasClass("showdrop")) {
            $target.addClass("showdrop");
          }
          else {
            $target.removeClass("showdrop");
          }
          return stopclick(e);
        });

        $(this).hover(function (e) {
          $(this).addClass("showdrop").addClass("hoverdrop");
        },
          function (e) {
            $(this).removeClass("showdrop").removeClass("hoverdrop");
          }
        );
      });
    },
    initjoin: function () {
      var _this = this;
      $mailmodallinks = $(".modal-join,[href*='/mailing-list']");
      if (!$mailmodallinks.length)
        return;
      _this.$joinmodal = new Foundation.Reveal($('#modalJoin'));
      $mailmodallinks.on('click', function (e) {
        _this.$joinmodal.open();
        return stopclick(e);
      });
    },
    scrolltopdisplay: function () {
      var _this = this;
      var scrolltopbtn = $('.scrolltop');
      if ($(window).scrollTop() > 300) {
        scrolltopbtn.addClass('show');
      } else {
        scrolltopbtn.removeClass('show');
      }
    },
    contentadjustments: function () {
      var _this = this;

      $(".list-boxes").each(function () {
        $lis = $(this).find("li");
        if ($lis.length == 5) {
          $(this).addClass("box5");
        }
        if ($lis.length == 7) {
          $(this).addClass("box7");
        }
        if ($lis.length == 9) {
          $(this).addClass("box9");
        }
      });

      $(".lazybg").on("lazyload", function () {
        var $this = $(this);
        if (!$this.hasClass("lazybg")) {
          return;
        }
        if ($this.data("bgsrc")) {
          console.log("[lazybg] lazy loading.. ", $this.data("bgsrc"));
          $this.css("background-image", "url('" + $this.data("bgsrc") + "')");
          $this.data("bgsrc", "");
          $this.removeClass("lazybg");
          $this.addClass("lazydone");
        }

      });


      // add stroke to em within blockquote
      $("blockquote, .quote_em, h1").each(function () {
        $(this).find("em").wrap("<div class='emholder'><div class='emwrap'></div></div>");
        $(this).find(".emwrap").append("<div class='emstroke'><div></div></div>");
      });

      // turn impact boxes into slider 
      $(".layout_impact").each(function () {
        //continue;
        var $this = $(this);
        var $next = $(this).next();
        if ($next.hasClass("layout_impact")) {
          $this.find(".impact_slide").wrap("<div class='impact_slides'></div>")
          var $slideholder = $this.find(".impact_slides");
          // POSSIBLE TODO, REPLICATE H1
          //var $h1 = $this.find(".impact_text h1");
          //          console.log("impact group");
          while ($next.hasClass("layout_impact")) {
            $current = $next;
            $slideholder.append($current.find(".impact_slide"));
            $next = $current.next();
            $current.remove();
            // console.log($next);
          }
        }


      });

      var $impactslidecontainer = $(".impact_slides");
      if ($impactslidecontainer.length) {
        var $wrap = $impactslidecontainer.parents(".impact_wrap");
        //$wrap.addClass("activeslider");
        var $prevArrow = $wrap.find(".slider-previous");
        var $nextArrow = $wrap.find(".slider-next");
        // TODO: ADD ARROWS: : not working, not clickable

        $impactslidecontainer.each(function () {
          var $this = $(this);
          $this.slick({
            arrows: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            dots: true,
            autoplay: false,
            autoplaySpeed: 5000,
            speed: 500,
            fade: true,
          });
          PJS.layout.pagesliders.push($this);
          $this.parents(".layout_impact").addClass("layout_impactslides");

          $this.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            var $next = $(this).find('[data-slick-index="' + nextSlide + '"]');
            // $(this).find('[data-slick-index="'+nextSlide+'"]').find(".impact_box").trigger("anim");
            $next.find(".impact_boxes").trigger("animboxes");
          });

        });

      }

      // make news list same sizes
      if (PJS.helpers.isDesktopSize()) {
        $(".news-list").each(function () {
          var $boxes = $(this).find(".post-content-wrap");
          var _minheight = 100;
          $boxset = [];
          $boxes.each(function (i) {
            $boxset.push($(this));
            _minheight = Math.max(_minheight, $(this).height());
            if ((i + 1) % 3 == 0 && i > 1) { // reset on each new row
              $.each($boxset, function (i, $j) {
                $j.css("min-height", _minheight + "px");
              })
              $boxset = [];
              _minheight = 100;
            }

          });
          $.each($boxset, function (i, $j) {
            $j.css("min-height", _minheight + "px");
          });
        });
      }


      //  // add stroke to block text element
      // $(".cause-text h1").each(function() {
      //   var _text = $(this).text();
      //   $(this).addClass("emholder causelabel");
      //   $(this).html("<div class='emtext'>"+_text+"</div><div class='emstroke'><div></div></div>");        
      // });

      // add spacing for quote bio overhang
      $(".style-quote-bio").each(function () {
        var $afterq = $(this).next();
        if ($afterq.hasClass("layout_block")) {
          $afterq.addClass("layout_biopush");
        }
      });

      // SCROLL TOP
      var scrolltopbtn = $('.scrolltop');

      scrolltopbtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, '300');
      });

      $("[href='#']").on('click', function (e) {
        e.preventDefault();
      });

      // readjust header put after content img
      // $(".content_img_holder").each(function() { 
      //   var $beforeblock = $(this).prev();
      //   if ($beforeblock.hasClass("section-title")) {
      //     $beforeblock.insertAfter($(this));
      //   }
      // });

      $(".list-board2-collapse,.list-board1-collapse,.board-wrap").each(function () {
        var $this = $(this);
        $h2 = $(this).prev("h2");
        if ($h2.length) {
          var $wrap = "<div class='boardwrap'></div>";
          $h2.wrap($wrap);
          var $bwrap = $h2.parent(".boardwrap");
          $bwrap.append($this);

          var $blist = $bwrap.find('.list-board2-collapse,.list-board1-collapse,.board-wrap');
          $blist.slideUp();
          $blist.wrap("<div class='listwrap'></div>")
          $bwrap.on("click", function () {
            if ($(this).hasClass("open")) {
              $blist.slideUp();
              $(this).removeClass("open");
            }
            else {
              $blist.slideDown();
              $(this).addClass("open");
            }
          });
        }
      });

      $("a.board-layout").on("click", function (e) {
        e.stopPropagation();
        return true;
      });

      // $(".list-board2,.list-board1").each(function() {
      //   $(this).find("li").each(function() {
      //     var _text = $(this).html().split(",");;
      //     var _name = _text[0];
      //     var _remaining = "";
      //     if (_text.length > 2) {
      //       _text.shift();
      //       _remaining = _text.join();
      //     }
      //     $(this).html("<span class='bname'>" + _name + "</span>" + _remaining);
      //   });
      // });
    },
    nextImpactMap: function () {
      var _this = PJS.layout;
      clearTimeout(_this.impactmaptimer);
      //console.log("next impact map");
      var $impactmap = $(".layout_impactmap");
      var $maplabels = $impactmap.find(".maplabel");
      $maplabels.each(function (i) {
        if (i == _this.impactmapactive) {
          $(this).trigger("click");

        }
      });
      _this.impactmapactive++;
      if (_this.impactmapactive + 1 > $maplabels.length) {
        _this.impactmapactive = 0;
      }
      _this.impactmaptimer = setTimeout(_this.nextImpactMap, _this.impactmapdelay);
    },
    initImpactMap: function () {
      var _this = this;

      var $impactmap = $(".layout_impactmap");
      if (!$impactmap.length) {
        return;
      }
      var $maplabels = $impactmap.find(".maplabel");
      var $allitems = $impactmap.find(".maplabel, .county, .im-overlay");

      // hover over each, set corresponding active
      $maplabels.each(function () {
        var $label = $(this);
        var $county = $impactmap.find(".county." + $label.data("county"));
        var $overlay = $impactmap.find(".im-overlay." + $label.data("county"));
        var $stats = $overlay.find(".statnum");

        var $hoveritem = $label.add($county);
        $hoveritem.on("mouseover click", function () {
          if (!$(this).hasClass("active")) {
            $allitems.removeClass("active");
            $label.addClass("active");
            $county.addClass("active");
            $overlay.addClass("active");
            clearTimeout(_this.impactmapanimtimer);
            _this.impactmapanimtimer = setTimeout(function () {
              $stats.trigger("anim");
            }, 100);

            clearTimeout(_this.impactmaptimer);
          }
        });
        $hoveritem.on("mouseout", function () {
          clearTimeout(_this.impactmaptimer);
          _this.impactmaptimer = setTimeout(_this.nextImpactMap, _this.impactmapresume);
        });
      });
      // start auto scroll through
      _this.nextImpactMap();
    },
    initPartners: function () {
      var _this = this;


      $(".home-partners").each(function () {
        var _pid = $(this).data("id");
        var $slider = $(this).find(".partners-slider");
        var $dotloc = $(this).find(".dotloc");
        $slider.slick({
          arrows: false,
          dots: true,
          appendDots: $dotloc,
          autoplay: false,
          autoplaySpeed: PJS.layout.slidespeed,
          speed: 500,
          fade: true,
          customPaging: function (slider, i) {
            var img = partnerimgs[_pid][i];
            return '<button class="slidebutton clickonhover" type="button" role="tab" id="slick-slide-control1' + i + '" aria-controls="slick-slide1' + i + '" tabindex="' + i + '"><div class="buttonwrap"><div class="bgimg" style="background-image:url(\'' + img + '\');"></div></div><div class="bar"></div></button>'
          },
        });
        //console.log("ADD PARTNER SLIDER");
        PJS.layout.pagesliders.push($slider);

      });



    },
    initCauses: function () {
      var _this = this;

      var $causecontainer = $('.cause-slider');

      if (!$causecontainer.length) {
        return;
      }

      var dataid = $causecontainer.data("id");
      
      var sectionlabels = causelabels[dataid];
      var sectionimgs = causeimgs[dataid];
 
      $causecontainer.slick({
        arrows: false,
        dots: true,
        autoplay: false,
        autoplaySpeed: PJS.layout.slidespeed,
        speed: 500,
        fade: true,
        customPaging: function (slider, i) {
          var label = sectionlabels[i];
          var img = sectionimgs[i];
          return '<button class="causebutton clickonhover" type="button" role="tab" id="slick-slide-control1' + i + '" aria-controls="slick-slide1' + i + '" tabindex="' + i + '"><div style="background-image:url(\'' + img + '\');"></div><span>' + label + '</div></button>'

        },
      });
      $causecontainer.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        var $next = $(this).find('[data-slick-index="' + nextSlide + '"]');
        var $lbg = $next.find(".lazybg");
        if ($lbg.length) {
          $lbg.trigger("lazyload");
        }
        //console.log("NEXT SLIDE");
        //console.log($next);
      });

      //console.log("ADD CAUSE SLIDER");
      PJS.layout.pagesliders.push($causecontainer);



    },
    initslider: function () {
      var _this = this;

      var $slidecontainer = $('.hero-slider');
      var $slides = $(".hero-slider .slider-slide");

      var $prevArrow = $(".slider-previous");
      var $nextArrow = $(".slider-next");

      var animationdelay = 600;

      if ($slides.length < 1 || !$("body").hasClass("home")) {
        setTimeout(function () {
          $(".hero_container").addClass("loaded");

        }, animationdelay);

      }
      if ($slides.length < 1) {
        return;
      }

      $slidecontainer.slick({
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        dots: true,
        autoplay: !PJS.helpers.isDev(),
        autoplaySpeed: PJS.layout.slidespeedhero,
        speed: 2000,
        fade: true,
      });
      $slidecontainer.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        var $next = $(this).find('[data-slick-index="' + nextSlide + '"]');
        var $lbg = $next.find(".lazybg");
        if ($lbg.length) {
          $lbg.trigger("lazyload");
        }
        //console.log("NEXT SLIDE");
        //console.log($next);
      });
      setTimeout(function () {
        $(".hero_text_pad").removeClass("clear");
        $slidecontainer.addClass("loaded"); // triggers css animations on first slide                 
      }, animationdelay);
    },
    initwaypoints: function () {
      console.log('[initwaypoints]');
      var _this = this;
      if (!$('.section-header').length) return;
      _this.waypoints = $('.section-header').waypoint({
        offset: function () {
          if (!this.element.id) {
            return 0;
          }
          if ($(".page-header").hasClass("fixed")) {
            return $(".page-header").height();
          }
          return 0;
        },
        handler: function (direction) {
          if (PJS.layout.isscrolling) return;

          //console.log("scrolltop" + $(window).scrollTop());
          if (this.element.id && $(window).scrollTop() > 100) {
            console.log("[initwaypoints] change " + this.element.id);
            PJS.helpers.updateState("#" + this.element.id);
          }
          else {
            //console.log("[initwaypoints] null ");
            PJS.helpers.updateState("");
          }
        }
      });
    },
    // check if submenu exceeds image and make image taller
    submenuvert: function () {
      $hero = $(".hero_image");
      $subnav = $(".sub_nav_block");
      if (!$(".sub_nav_block").length || !$hero.length) {
        return;
      }
      if (PJS.helpers.isDesktopSize()) {
        $hero.css("height", "");
        if ($subnav.height() > $hero.height()) {
          $hero.height($subnav.height());
        }
      }
      else {
        $hero.css("height", "");
      }
    },
    // Count rows on boxes and setup classes
    bodyboxes: function () {
      rowcount = 0;
      $(".inner-content .layout_block").each(function () {
        $this = $(this);

        if ($this.hasClass("style-size-3")) {
          rowcount = 0;
          return;
        }

        if (rowcount == 0) {
          $this.addClass("row-first");
        }
        if ($this.hasClass("style-size-2")) {
          rowcount += 8;
        }
        if ($this.hasClass("style-size-1")) {
          rowcount += 4;
        }
        if (rowcount == 12) {
          $this.addClass("row-last");
          rowcount = 0;
        }
      });
    },
    searchmobile: function () {
      var _this = this;
      $("a[data-toggle='search-overlay']").click(function () {
        $msearch = $("." + $(this).data("target"));
        if (!$(this).hasClass("searchopen")) {
          $(this).addClass("searchopen");
          $msearch.fadeIn();
          $msearch.find(".search-field").focus();
        }
        else {
          $(this).removeClass("searchopen");
          $msearch.fadeOut();
        }
        _this.mobilenavshow = !_this.mobilenavshow;

      });
    },
    searchempty: function () {
      $(".searchform").each(function () {
        $(this).on("submit", function () {
          $sf = $(this).find(".search-field");
          if ($sf.length) {
            if ($sf.val() == "") {
              alert("Please enter a search term");
              $sf.focus();
              return false;
            }
          }
          return true;
        });
      });
    },
    hashCheck: function () {
      console.log("[hashCheck]");
      var _this = this;
      if (window.location.hash != "") {
        hashlink = window.location.hash;
        console.log(hashlink);
        _this.scrolltohash(hashlink);
      }
    },
    linkscroll: function () {
      var _this = this;
      $(".linkscroll").click(function () {
        _id = $(this).attr("data-id");
        hashlink = "#" + _id;
        _this.scrolltohash(hashlink);
      });
    },
    scrolltohash: function (hashlink) {
      var _this = this;
      console.log("[scrolltohash] " + hashlink);
      $item = $(hashlink);
      if ($item.length) {
        //PJS.layout.stickheader(true);
        PJS.helpers.updateState(hashlink);
        _top = $item.offset().top;
        PJS.layout.isscrolling = true;

        clearTimeout(_this.scrolltimer);
        _this.scrolltimer = setTimeout(function () {
          console.log("[scrolltohash] animate");
          $('html, body').animate({
            scrollTop: $item.offset().top - $(".main-nav-wrapper").height() - 20
          }, function () {
            PJS.layout.isscrolling = false;
          });
        }, 500); // add delay to allow for proper positioning

      } else {
        console.log("[scrolltohash] no item for: " + hashlink);
      }

    },
    menufixes: function () {
      var _this = this;
      var path = document.location.pathname.replace(/^\/|\/$/g, ''); // strip slashes from ends
      var _initialpath = path.substring(0, path.indexOf('/'));

      _navlink = "";
      switch (_initialpath) {
        case "news":
        case "news-tag":
          _navlink = "news";
          break;
        case "events":
        case "event-tag":
        case "past-events":
          _navlink = "events";
          break;
      }

      if (_navlink != "") {
        $(".menu-item a[href*='/" + _navlink + "/']").parent().addClass("active");
      }


      $menus = $(".menu");
      $menus.each(function () {

        // only one active item per menu, fixes sub page menu active demarkation
        $activemenus = $(this).find(".menu-item.active");
        if ($activemenus.length > 1) {
          $activemenus.removeClass("active");
          $activemenus.first().addClass("active");
        }

        _previtemtype = "";
        $previtem = null;
        $(".menu-item").each(function () {
          _itemtype = "depth3";
          if ($(this).hasClass("depth1")) {
            _itemtype = "depth1";
          }
          if ($(this).hasClass("depth2")) {
            _itemtype = "depth2";
          }
          if ($(this).hasClass("depth3")) {
            _itemtype = "depth3";
          }
          if ($(this).hasClass("depth4")) {
            _itemtype = "depth4";
          }
          //console.log(_itemtype);
          if (_itemtype != _previtemtype && $previtem && $previtem.length) {
            $previtem.addClass("lastofdepth");
          }
          if (_itemtype != _previtemtype) {
            $(this).addClass("firstofdepth");
          }
          _previtemtype = _itemtype;
          $previtem = $(this);

        });


      });


    },
    outboundlinks: function () {
      // open all outbound links in target blank unless already specified
      var allLinks = $("A[href^='http'],AREA[href^='http']");  // must start with http (outgoing), but can't link back to visitphilly.com
      allLinks = allLinks.not("[href*='://" + window.location.hostname + "']");
      allLinks = allLinks.not("[href*='://www.unitedforimpact.org']");
      allLinks = allLinks.not("[href*='://unitedforimpact.org']");
      //allLinks = allLinks.not("[href$='.pdf']");
      //allLinks = allLinks.not("[href$='.mp3']");
      allLinks.each(function (i) {
        atarget = $(this).attr("target");
        if (!atarget) {
          $(this).attr("target", "_blank");
        }
      });
    },
    donatelinks: function () {
      var _this = this;

      $(".donate-link").each(function () {
        var $this = $(this);
        _this.donatetrack($this);
      });

      // Women United // https://epledge.unitedforimpact.org/epledge/comm/SinglePageRegPledge.jsp?DA=18082552

      var customdonate = [
        "https://epledge.unitedforimpact.org/epledge/comm/SinglePageRegPledge.jsp?SA=20634754",
        "https://epledge.unitedforimpact.org/epledge/comm/SinglePageRegPledge.jsp?DA=no",
        "/donate",
        "https://unitedforimpact.org/donate",
        "https://www.unitedforimpact.org/donate",
        "http://unitedforimpact.org/donate",
        "http://www.unitedforimpact.org/donate",
      ]

      $.each(customdonate, function (k, v) {
        var $altlinks = $("a[href^='" + v + "']");
        $altlinks.each(function () {
          var $this = $(this);
          if ($this.attr("data-tracking") == "set") {
            return true;
          }
          _this.donatetrack($this);
        });

      });

    },
    donatetrack: function ($link) {

      var _pathname = window.location.pathname;
      var _cat = "Donate Click"
      var _action = _pathname;

      var $this = $link;
      var _text = $.trim($this.text());
      var _type = "CustomContent";
      if ($this.data("donate")) { // use attribute for type if available
        _type = $this.data("donate");
      }
      else {
        if ($this.parents(".hero_container").length) { // check if in hero
          _type = "Hero";
        }
      }
      var _label = _type + " [" + _text + "]";

      $this.on("click", function () {
        PJS.helpers.firecustomGTMEvent(_cat, _label, _action);
      });
      $this.attr("data-tracking", "set");
    },
    offcanvasmenu: function () {
      // add overview for side menu
      $(".off-canvas .is-accordion-submenu-parent").each(function () {

        // duplicate and add in overview link
        
        if (!($(this).hasClass("menu-stub"))) {
            _href = $(this).find("> a").attr("href");
            $ul = $(this).find("> ul");
            $li = $(this).find("li").first().clone();
            $li.addClass("overview").removeClass("active");
            $li.find("a").text("Overview").attr("href", _href);
            $li.prependTo($ul);

            // open current active menu
            if ($(this).hasClass("current-menu-item") || $(this).hasClass("current-page-ancestor")) {
            $(this).find("> a").trigger("click");
            }
        }

      });

    },
    fixedheader: function () {
      var _this = this;
      _this.stickheader(PJS.helpers.lastScrollTop > 0);

    },

    stickheader: function (_stick) {
      var $body = $("body");
      if (_stick) {
        //$header.css("height",_this.headerHeight);
        $body.addClass("pagescroll");
      }
      else {
        $body.removeClass("pagescroll");
      }
    }
  };
})(jQuery);
